import { render, staticRenderFns } from "./edit-vertical.component.html?vue&type=template&id=75960de5&scoped=true&external"
import script from "./edit-vertical.component.vue?vue&type=script&lang=ts"
export * from "./edit-vertical.component.vue?vue&type=script&lang=ts"
import style0 from "./edit-vertical.component.css?vue&type=style&index=0&id=75960de5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75960de5",
  null
  
)

export default component.exports